// extracted by mini-css-extract-plugin
export default {"formContainer":"styles_formContainer__MunxH","backBtn":"styles_backBtn__d5BSU"};